var ODThemeManager = /** @class */ (function () {
    function ODThemeManager(def) {
        this.def = def;
    }
    return ODThemeManager;
}());
export { ODThemeManager };
//# sourceMappingURL=ODThemeManager.js.map